/**
 * UI组件, 统一使用饿了么桌面端组件库(https://github.com/ElemeFE/element）
 *
 * 使用:
 *  1. 项目中需要的组件进行释放(解开注释)
 *
 * 注意:
 *  1. 打包只会包含释放(解开注释)的组件, 减少打包文件大小
 */
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import {
    Avatar,
    Table,
    TableColumn,
    Dialog,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Input,
    InputNumber,
    Switch,
    Select,
    Option,
    OptionGroup,
    Button,
    DatePicker,
    TimeSelect,
    TimePicker,
    Popover,
    Form,
    FormItem,
    Slider,
    Icon,
    Row,
    Col,
    Upload,
    Card,
    Cascader,
    Container,
    Tag,
    Header,
    Aside,
    Main,
    Footer,
    Message, MessageBox,
} from 'element-ui'
Vue.use(Avatar)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Button)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Popover)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Slider)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Upload)
Vue.use(Card)
Vue.use(Cascader)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tag)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
